module.exports = __webpack_public_path__ + "img/colaborador(1).c3b07bb2.jpeg";